/* eslint-disable no-console */
import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
	selectIsDesktop,
	selectSwishQRCodeFlow,
	selectSwishQRCodeFlowDesktop,
	selectSwishRedirectFlowMobile
} from '~/components/brand/ducks/selectors';
import { SWISH } from '~/components/payment/beta/constants';
import NativeAppPrompt from '~/components/payment/deposit/components/native-app-prompt';
import { insertTrackEvent } from '@comeon/analytics';

const SwishAppPrompt = ({
	paymentResult,
	cancelAppDepositRequest,
	handleAppDepositRequestSuccess,
	quickDepositFlow
}) => {
	const [hidePromptFlag, setHidePromptFlag] = useState(true); // hide prompt to avoid showing during app redirection
	const [showSpinner, setShowSpinner] = useState(false);
	const [QRCodeData, setQRCodeData] = useState('');
	const swishQRCodeFlowDesktop = useSelector(selectSwishQRCodeFlowDesktop);
	const swishMobileBeta = useSelector(selectSwishRedirectFlowMobile);
	const swishQRCodeFlow = useSelector(selectSwishQRCodeFlow);
	const isDesktop = useSelector(selectIsDesktop);
	const { appUrl, qrCode } = paymentResult?.sendHandlerData || paymentResult || {};

	// callback to set QR code, on mobile show QR code only if users want
	const setQRCode = useCallback(() => {
		insertTrackEvent({
			category: 'Deposit',
			action: 'Swish beta QR - Deposit Details',
			label: `accHistRef: ${paymentResult?.accHistRef} - appUrl: ${appUrl}`
		});
		setQRCodeData(qrCode);
	}, [appUrl, paymentResult?.accHistRef, qrCode]);

	useEffect(() => {
		if (swishMobileBeta && appUrl) {
			// Deep link app redirection
			window.location.href = decodeURIComponent(appUrl);
			setTimeout(() => setHidePromptFlag(false), 1200);
		} else {
			setHidePromptFlag(false); // show prompt without delay if there is no mobile app redirection
		}

		// set QR code for desktop only now
		if (swishQRCodeFlow && isDesktop) {
			setQRCode();
		}
	}, [appUrl, isDesktop, setQRCode, swishMobileBeta, swishQRCodeFlow]);

	const cancelHandler = () => {
		try {
			setShowSpinner(true);

			cancelAppDepositRequest();

			insertTrackEvent({
				category: 'Deposit',
				action: 'Swish user cancel - Deposit Details',
				label: `accHistRef: ${paymentResult?.accHistRef} - appUrl: ${appUrl} - isDesktopFlow: ${
					swishQRCodeFlow && isDesktop
				}`
			});
		} catch (error) {
			console.error('Something went wrong with cancelAppDepositRequest', error);
		} finally {
			setShowSpinner(false);
		}
	};

	return (
		<>
			{!hidePromptFlag ? (
				<NativeAppPrompt
					onNoClick={cancelHandler}
					quickDepositFlow={quickDepositFlow}
					accHistRef={paymentResult?.accHistRef}
					onPaymentSuccess={handleAppDepositRequestSuccess}
					QRCodedata={QRCodeData}
					selectedMethod={SWISH}
					swishQRCodeFlowDesktop={swishQRCodeFlowDesktop}
					swishMobileBeta={swishMobileBeta}
					setQRCode={setQRCode}
				/>
			) : null}
			{showSpinner ? <div className="spinner u-z-index-spinner" /> : null}
		</>
	);
};

export default SwishAppPrompt;
